import { useEffect, useState } from "react";
import Table from "../common/table";
import { format } from "date-fns";
import apiCondensadores from "../../services/apis/apiCondensadores";
import { orderBy } from "../../funcs";
import apiVentilador from "../../services/apis/apiVentilador";
import apiBombas from "../../services/apis/apiBomba";

export default function Condensadores() {

    const [leituras, setLeituras] = useState([]);
    const [ventiladores, setVentiladores] = useState([]);
    const [bombas, setBombas] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const res = await apiCondensadores.getByUnidadeId();
                const condensadores = res.data;
                const leituraCondensadores = condensadores.map(({leiturasCondensadores}) => (leiturasCondensadores[0]));                
                orderBy(leituraCondensadores, "condensadorId");
                setLeituras(leituraCondensadores);
    
                const ventiladores = (await apiVentilador.getByUnidadeIdV2()).data;
                const bombas = (await apiBombas.getByUnidadeIdV2()).data;

                setBombas(bombas);
                setVentiladores(ventiladores);
            } catch (error) {
                
            }

        })();
    },[]);

    const getPotenciaTotal = (condensadorId) => {
        let potenciaTotal = 0;
        ventiladores.forEach((ventilador) => {
            if(ventilador.condensadorId === condensadorId) {
                potenciaTotal += ventilador?.leiturasVentiladores[0]?.potenciaCalculada ?? 0;
            }
        });
        bombas.forEach((bomba) => {
            if(bomba.condensadorId === condensadorId) {
                potenciaTotal += bomba?.leiturasBombas[0]?.potenciaCalculada ?? 0;
            }
        });
        return potenciaTotal;
    }

    return 	<div className="w-full">
        <Table.Root>
            <Table.Head>
                <Table.Header>CON id</Table.Header>
                <Table.Header>Ligado</Table.Header>
                {/* <Table.Header>Status</Table.Header> */}
                <Table.Header>Data hora</Table.Header>
                <Table.Header>T. entrada</Table.Header>
                <Table.Header>T. saída</Table.Header>
                <Table.Header>Umidade relativa entrada</Table.Header>
                <Table.Header>Umidade relativa saída</Table.Header>
                <Table.Header>Velocidade ar entrada</Table.Header>
                <Table.Header>Potência Total</Table.Header>
            </Table.Head>
            <Table.Body>
                {leituras.map(
                    (leitura) => (
                        <Table.Row
                            key={leitura.id}
                        >
                            <Table.Data>{leitura.condensadorId}</Table.Data>
                            <Table.Data>{leitura.ligado ? "on" : "off"}</Table.Data>
                            <Table.Data>{format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss")}</Table.Data>
                            <Table.Data>{leitura.temperaturaEntrada}</Table.Data>
                            <Table.Data>{leitura.temperaturaSaida}</Table.Data>
                            <Table.Data>{leitura.umidadeRelativaEntrada}</Table.Data>
                            <Table.Data>{leitura.umidadeRelativaSaida}</Table.Data>
                            <Table.Data>{leitura.velocidadeArEntrada}</Table.Data>
                            <Table.Data>{getPotenciaTotal(leitura.condensadorId).toFixed(2)}</Table.Data>
                        </Table.Row>
                    )
                )}
            </Table.Body>
        </Table.Root>
    </div>
}